// extracted by mini-css-extract-plugin
export default {"textContainer":"ToastBody_textContainer__XOiqI"};